export default "__VITE_ASSET__a556d73c__"